import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["form", "from", "to", "duration"]

    lastSelectedDuration = 7; // default, smallest pauseable duration

    connect() {
        if (this.hasFromTarget) {
            this.fromInput = this.fromTarget.querySelector('input[type="text"]')
        }
        if (this.hasToTarget) {
            this.toInput = this.toTarget.querySelector('input[type="text"]')
        }

        if (this.fromInput && this.toInput) {
            this.fromInput.addEventListener('change', this.updateToDate.bind(this))
            this.maxDate = this.toInput.dataset.maxDate

            if (!this.hasDurationTarget && this.fromInput.value) {
                const fromDate = new Date(this.fromInput.value)
                const toDate = new Date(fromDate.getTime() + (this.lastSelectedDuration-1) * 24 * 60 * 60 * 1000)
                this.setToDate(this.formatDate(toDate))
            }
        }
    }

    addDays(event) {
        event.preventDefault()
        const days = parseInt(event.currentTarget.dataset.days)
        this.lastSelectedDuration = days;
        const fromDate = new Date(this.fromInput.value)

        const toDate = new Date(fromDate.getTime() + (days-1) * 24 * 60 * 60 * 1000)

        this.setToDate(this.formatDate(toDate))
    }

    updateToDate() {
        const fromDate = new Date(this.fromInput.value)
        const toDate = new Date(fromDate.getTime() + (this.lastSelectedDuration - 1) * 24 * 60 * 60 * 1000)
        this.setToDate(this.formatDate(toDate))
    }

    formatDate(date) {
        return date.toISOString().split('T')[0]
    }

    setToDate(value) {
        this.toInput.value = value
        const visibleInput = this.toInput.nextElementSibling
        if (visibleInput && visibleInput.tagName === 'INPUT') {
            visibleInput.value = value
        }
    }
}
